
<div class="clx-app-bar">
    <div class="left-side">
       <cx-menu text="File" i18n-text="@@benchmark-dashboard.menu.file" test-id="benchmark-dashboard.menu.file">
            <cx-menu-item i18n-text="@@benchmark-dashboard.menu.import" test-id="benchmark-dashboard.menu.import" text="Import" (click)="import()"></cx-menu-item>
            <cx-menu-item i18n-text="@@benchmark-dashboard.menu.export" test-id="benchmark-dashboard.menu.export" text="Export" (click)="export()"></cx-menu-item>
        </cx-menu>
        <cx-menu text="Windows" i18n-text="@@benchmark-dashboard.menu.windows" test-id="benchmark-dashboard.menu.windows">
            <cx-menu-item
                i18n-text="@@benchmark-dashboard.menu.dashboard-properties"
                test-id="benchmark-dashboard.menu.dashboard-properties"
                text="Dashboard Properties"
                (click)="propertiesWindow.window.visible = true"
                [selected]="propertiesWindow.window.visible"
            ></cx-menu-item>
            <cx-menu-item
                i18n-text="@@benchmark-dashboard.menu.datapoint-selection"
                test-id="benchmark-dashboard.menu.datapoint-selection"
                text="Datapoint Selection"
                (click)="datapointWindow.window.visible = true"
                [selected]="datapointWindow.window.visible"
            ></cx-menu-item>
            <cx-menu-item
                i18n-text="@@benchmark-dashboard.menu.favourites"
                test-id="dashboard.editor.menu.favourites"
                text="Favourites"
                (click)="favouritesWindow.window.visible = true"
                [selected]="favouritesWindow.window.visible"
            ></cx-menu-item>
        </cx-menu>
    </div>
</div>
<cx-frame name="dashboard-editor">
    <cx-panel [row]="0" [column]="0" width="auto" height="auto" name="applicaton-area">
        <clx-form #compareForm name="compare-form" [disableChangeChecking]="true">
            <clx-row is="config-row" has="big-layout">
                <clx-item has="full-size-columns">
                    <clx-label i18n="@@benchmark-dashboard.editor.value.aggregation">Value aggregation</clx-label>
                    <clx-select
                        [ngModel]="storage.data().valueAggregation"
                        (ngModelChange)="storage.set('valueAggregation', $event)"
                        test-id="benchmark-dashboard.configuration.value-aggregation"
                        name="valueAggregation"
                        #aggregation
                    >
                        <clx-value i18n="@@benchmark-dashboard.editor.commulative" value="commulative">Comulative</clx-value>
                        <clx-value i18n="@@general.value.avarage" value="average">Average</clx-value>
                        <clx-value i18n="@@general.value.max" value="max">Max</clx-value>
                        <clx-value i18n="@@general.value.min" value="min">Min</clx-value>
                    </clx-select>
                </clx-item>
                <clx-item has="full-size-columns">
                    <clx-label i18n="@@benchmark-dashboard.editor.aggregation.range">Aggregation range</clx-label>
                    <clx-select 
                        [ngModel]="storage.data()?.aggregationRange"
                        (ngModelChange)="storage.set('aggregationRange', $event)"
                        test-id="benchmark-dashboard.configuration.aggregation-range"
                        name="aggregationRange"
                    >
                        <clx-value i18n="@@general.value.day" value="day">Day</clx-value>
                        <clx-value i18n="@@general.value.week" value="week">Week</clx-value>
                        <clx-value i18n="@@general.value.month" value="month">Month</clx-value>
                        <clx-value i18n="@@general.value.year" value="year">Year</clx-value>
                    </clx-select>
                </clx-item>
                <clx-item has="full-size-columns">
                    <clx-label i18n="@@general.value.from">From</clx-label>
                    <clx-datetime
                        name="from"
                        type="date"
                        [ngModel]="storage.data()?.from"
                        (ngModelChange)="storage.set('from', $event)"
                        [displayFormat]="dateFormat"
                        [returnUTCDate]="true"
                        test-id="benchmark-dashboard.configuration.from"
                        [max]="storage.data()?.to - 1"
                        [keepInvalidValue]="true"
                        [showWeekNumbers]="true"
                    >
                        <clx-validation type="required"></clx-validation>
                        <clx-validation
                            type="maxdate"
                            [max]="storage.data()?.to - 1"
                            text="The from date must be lower than the to date!"
                            i18n-text="@@benchmark-dashboard.from.validation.text"
                        ></clx-validation>
                    </clx-datetime>
                </clx-item>
                <clx-item has="full-size-columns">
                    <clx-label i18n="@@general.value.to">To</clx-label>
                    <clx-datetime 
                        name="to"
                        #to
                        type="date"
                        [max]="currentDate"
                        [ngModel]="storage.data()?.to"
                        (ngModelChange)="setToDate($event)"
                        [displayFormat]="dateFormat"
                        [returnUTCDate]="true"
                        [showWeekNumbers]="true"
                        test-id="benchmark-dashboard.configuration.to"                        
                    >
                        <clx-validation type="required"></clx-validation>
                        <clx-validation type="maxdate" [max]="currentDate"></clx-validation>
                    </clx-datetime>
                </clx-item>
                <clx-item  has="full-size-columns">
                    <clx-label>
                        <clx-checkbox
                            name="compare"
                            #compareBox
                            [value]="storage.data()?.compareRange ? true : false"
                            (click)="compareCheckboxChanged(!compareBox.value)"
                            test-id="benchmark-dashboard.configuration.compare"
                        ></clx-checkbox><span i18n="@@benchmark-dashboard.configuration.compare">Compare with last:</span></clx-label>
                    <clx-select 
                        [ngModel]="storage.data()?.compareRange"
                        (valueChanged)="storage.set('compareRange', $event)"
                        [disabled]="storage.data()?.compareRange ? null : true"
                        name="compareRange"
                        test-id="benchmark-dashboard.configuration.compare-range"
                    >
                        <clx-value i18n="@@general.value.day" value="day">Day</clx-value>
                        <clx-value i18n="@@general.value.week" value="week">Week</clx-value>
                        <clx-value i18n="@@general.value.month" value="month">Month</clx-value>
                        <clx-value i18n="@@general.value.year" value="year">Year</clx-value>
                    </clx-select>
                </clx-item>
                <clx-item>
                    <button
                        i18n-title="benchmark-dashboard.button.refresh"
                        test-id="benchmark-dashboard.button.refresh"
                        title="update"
                        is="refresh-button"
                        class="default small icon update-button fa-refresh fa up-to-date"
                        [attr.now]="hasChanges ? 'has-changes' : null"
                        (click)="updateBar()"
                    ></button>
                 
                </clx-item>
            </clx-row>
        </clx-form>
        <div is="enery-bar-panel" style="overflow: auto; width:100%" (drop)="handleTileDrop($event)">
            <benchmark-bar-chart
                (dropped)="handleTileDrop($event)"
                #benchmarkChart
                [width]="storage.data()?.chartWidth"
                [showSeriesLabel]="storage.data()?.showSeriesLabel"
                [formatNumberAsFloat]="aggregation.value === 'average' ? true : false"
            ></benchmark-bar-chart>
        </div>
    </cx-panel>
    <cx-panel [row]="0" [column]="1" width="225" height="auto" [windowTarget]="true" name="right-panel" (onSizeChanged)="benchmarkChart.onResize()">
        <datapoint-selector-window 
            (dropped)="handleTileDrop($event)"
            [datapointIds]="storage.data().charts[0].datapoints"
            #datapointWindow
        ></datapoint-selector-window>
        <benchmark-favourites-window #favouritesWindow></benchmark-favourites-window>


        <benchmark-dashboard-property-window
            #propertiesWindow
        ></benchmark-dashboard-property-window>
    </cx-panel>
</cx-frame>